import { injectReducer } from '../../store/reducers'
import { actions } from './modules/doctorDetail'

export default (store) => ({
  path : 'doctor/:id',
  /*  Async getComponent is only invoked when route matches   */
  getComponent (nextState, cb) {
    /*  Webpack - use 'require.ensure' to create a split point
        and embed an async module loader (jsonp) when bundling   */
    require.ensure([], (require) => {
      /*  Webpack - use require callback to define
          dependencies for bundling   */
      const Setting = require('./containers/DoctorDetailContainer').default
      const reducer = require('./modules/doctorDetail').default

      /*  Add the reducer to the store on key 'counter'  */
      injectReducer(store, { key: 'doctorDetail', reducer })
        var doctorId = nextState.params.id
      store.dispatch(actions.loadDoctor(false, doctorId))
      /*  Return getComponent   */
      cb(null, Setting)

    /* Webpack named bundle   */
    }, 'doctorDetail')
  }
})



// WEBPACK FOOTER //
// ./src/routes/DoctorDetail/index.js